// Debug Mode Control — JRSBASE-V8.3.0-09102026-BYOB — debug always ON
(function() {
  var DEBUG_MODE = true;

  var _themeId = String(window._bcThemeId || window._mrkThemeId || 'base');
  var _themeVersion = String(window._bcThemeVersion || window._mrkThemeVersion || 'JRSBASE-V8.3.0-09102026-BYOB');
  var _prefix = '[' + _themeVersion + '][' + _themeId + ']';
  var _makeWriter = function(method) {
    if (!DEBUG_MODE) return function(){};
    return function() {
      var args = Array.prototype.slice.call(arguments);
      args.unshift(_prefix);
      if (console && typeof console[method] === 'function') {
        console[method].apply(console, args);
      }
    };
  };

  var debugObj = window.bcDebug || window.betterConversionsDebug || window.mrkDebug || {};
  debugObj.enabled = DEBUG_MODE;
  debugObj.log = _makeWriter('log');
  debugObj.warn = _makeWriter('warn');
  debugObj.error = _makeWriter('error');
  debugObj.info = _makeWriter('info');
  window.bcDebug = debugObj;
  window.betterConversionsDebug = debugObj;
  window.mrkDebug = debugObj;
})();

var JRS_BUILD_VERSION = '7.0.0';
var JRS_THEME_NAME = 'base';

let nextButton = document.querySelector(".custom-product-form-next");
let newnextButton = document.querySelector(".custom-product-form-next-new");
let mql = window.matchMedia("(max-width: 768px)");
let step1 = document.querySelector(".step-1");
let step2 = document.querySelector(".step-2");
let step3 = document.querySelector(".step-3");
let statusEl = document.querySelector(".custom-product-form-status");
let atcButton = document.querySelector(".mrk-btns-container");
let formLabelEl = document.querySelector(".custom-product-form-label");
let totalSteps = formLabelEl ? formLabelEl.getAttribute("data-steps") : null;
let formLabelHeading = formLabelEl;
let step2Label = document.querySelector(".step_2_label");
// When pdp-multistep-form-v2 is present, step-1/step-2 are replaced — skip legacy step bindings
if (!step1 || !step2 || !nextButton) {
  nextButton = null;
  newnextButton = null;
}
if (nextButton) nextButton.addEventListener("click", () => {
  if (!nextButton.classList.contains("disabled")) {
    if (step1.querySelector(".custom-product-form-tick").classList.contains("selected") && !step2.querySelector(".custom-product-form-tick").classList.contains("selected")) {
      if (!step2.querySelector(".custom-product-form-tick").classList.contains("selected")) {
        if (step1.querySelector("details").getAttribute("open") != null) {
          step1.querySelector(".custom-product-form-summary").click();
        }
        step2.classList.remove("hidden");
        // if (mql.matches) {
        //   if (document.querySelector("product-form-mrk")){
        //      document.querySelector("product-form-mrk").scrollIntoView({
        //         behavior: "smooth"
        //       }) 
        //   }          
        // }
        // else {
        //   document.querySelector("product-form-mrk").scrollIntoView({
        //     behavior: "smooth"
        //   })
        // }
        step2.querySelector(".custom-product-form-summary").click();
        nextButton.classList.add("disabled");
        if (totalSteps == "3") {
          formLabelHeading.innerHTML = "Step 2 of 3: Select Your Size for the Perfect Fit"
          nextButton.innerHTML = "Next: Confirm Your Order Details";
        }
        else if (totalSteps == "2") {
          formLabelHeading.innerHTML = "Step 2 of 2: Select Your Size for the Perfect Fit"
        }
      }
    }
    else if (step1.querySelector(".custom-product-form-tick").classList.contains("selected") && step2.querySelector(".custom-product-form-tick").classList.contains("selected")) {
      if (!step3.querySelector(".custom-product-form-tick").classList.contains("selected")) {
        if (step1.querySelector("details").getAttribute("open") != null) {
          step1.querySelector(".custom-product-form-summary").click();
        }
        if (step2.querySelector("details").getAttribute("open") != null) {
          step2.querySelector(".custom-product-form-summary").click();
        }
        
        // if (mql.matches) {
        //   if (document.querySelector("product-form-mrk")){
        //      document.querySelector("product-form-mrk").scrollIntoView({
        //         behavior: "smooth"
        //       }) 
        //   }
        // }
        // else {
        //   document.querySelector("product-form-mrk").scrollIntoView({
        //     behavior: "smooth"
        //   })
        // }

        //Ak-dd custom code
        step3.classList.remove("hidden");
        if (step3.querySelector("details").getAttribute("open") == null) {
          step3.querySelector(".custom-product-form-summary").click();
        }
        
        // const popup_btn = step3.querySelector("details .mrk-open-popup");
        // if(popup_btn){
        //   window.mrknavigateTo(0);
        //   popup_btn.click();
        // }
        window.mrknavigateTo(1);
        const customizer_popup_footer = document.querySelector(".mrk-product-csutomizer .mrk-steps-footer");
        if(customizer_popup_footer){
          customizer_popup_footer.classList.remove('hidden');
        }
        //End Ak-dd Custom code
        
        nextButton.classList.add("disabled");
        nextButton.classList.add("hidden");
        if (totalSteps == "3") {
          formLabelHeading.innerHTML = "Step 3 of 3: Finalise Your Order"
        }
      }
    }
  }
  else if (nextButton.classList.contains("disabled")) {
    if (!document.querySelectorAll(".custom-product-form-tick")[0].classList.contains("selected")) {
      statusEl.innerHTML = "Looks like you missed a step—choose your colour to proceed."
    }
    else if (!document.querySelectorAll(".custom-product-form-tick")[1].classList.contains("selected")) {
      statusEl.innerHTML = "Please choose a size to proceed with your order."
      if (step2.querySelector("details").getAttribute("open") == null) {
        step2.querySelector(".custom-product-form-summary").click();
      }
    }
    else if (!document.querySelectorAll(".custom-product-form-tick")[2].classList.contains("selected")) {
      statusEl.innerHTML = "Please choose an option to continue."
    }
  }
});

if (newnextButton) newnextButton.addEventListener("click", () => {
  if (!newnextButton.classList.contains("disabled")) {
    if (step1.querySelector(".custom-product-form-tick").classList.contains("selected") && !step2.querySelector(".custom-product-form-tick").classList.contains("selected")) {
      if (!step2.querySelector(".custom-product-form-tick").classList.contains("selected")) {
        if (step1.querySelector("details").getAttribute("open") != null) {
          step1.querySelector(".custom-product-form-summary").click();
        }
        step2.classList.remove("hidden");
        // if (mql.matches) {
        //   if (document.querySelector("product-form-mrk")){
        //      document.querySelector("product-form-mrk").scrollIntoView({
        //         behavior: "smooth"
        //       }) 
        //   }          
        // }
        // else {
        //   document.querySelector("product-form-mrk").scrollIntoView({
        //     behavior: "smooth"
        //   })
        // }
        step2.querySelector(".custom-product-form-summary").click();
        newnextButton.classList.add("disabled");
        if (totalSteps == "3") {
          formLabelHeading.innerHTML = "Step 2 of 3: Select Your Size for the Perfect Fit"
          newnextButton.innerHTML = "Next: Confirm Your Order Details";
        }
        else if (totalSteps == "2") {
          formLabelHeading.innerHTML = "Step 2 of 2: Select Your Size for the Perfect Fit"
        }
      }
    }
    else if (step1.querySelector(".custom-product-form-tick").classList.contains("selected") && step2.querySelector(".custom-product-form-tick").classList.contains("selected")) {
      if (!step3.querySelector(".custom-product-form-tick").classList.contains("selected")) {
        if (step1.querySelector("details").getAttribute("open") != null) {
          step1.querySelector(".custom-product-form-summary").click();
        }
        if (step2.querySelector("details").getAttribute("open") != null) {
          step2.querySelector(".custom-product-form-summary").click();
        }
        
        // if (mql.matches) {
        //   if (document.querySelector("product-form-mrk")){
        //      document.querySelector("product-form-mrk").scrollIntoView({
        //         behavior: "smooth"
        //       }) 
        //   }
        // }
        // else {
        //   document.querySelector("product-form-mrk").scrollIntoView({
        //     behavior: "smooth"
        //   })
        // }

        //Ak-dd custom code
        // step3.classList.remove("hidden");
        // if (step3.querySelector("details").getAttribute("open") == null) {
        //   step3.querySelector(".custom-product-form-summary").click();
        // }
        const popup_btn = step3.querySelector("details .mrk-open-popup");
        if(popup_btn){
          window.mrknavigateTo(0);
          $('.mrk-steps-footer').addClass('hidden');
          popup_btn.click();
        }
        //End Ak-dd Custom code
        
        // newnextButton.classList.add("disabled");
        // newnextButton.classList.add("hidden");
        if (totalSteps == "3") {
          formLabelHeading.innerHTML = "Step 3 of 3: Finalise Your Order"
        }
      }
        //Ak-dd custom code
      else{
        const popup_btn = step3.querySelector("details .mrk-open-popup");
        if(popup_btn){
          window.mrknavigateTo(0);
          popup_btn.click();
        }
      }
      //End Ak-dd Custom code
    }
  }
  else if (newnextButton.classList.contains("disabled")) {
    if (!document.querySelectorAll(".custom-product-form-tick")[0].classList.contains("selected")) {
      statusEl.innerHTML = "Looks like you missed a step—choose your colour to proceed."
    }
    else if (!document.querySelectorAll(".custom-product-form-tick")[1].classList.contains("selected")) {
      statusEl.innerHTML = "Please choose a size to proceed with your order."
      if (step2.querySelector("details").getAttribute("open") == null) {
        step2.querySelector(".custom-product-form-summary").click();
      }
    }
    else if (!document.querySelectorAll(".custom-product-form-tick")[2].classList.contains("selected")) {
      statusEl.innerHTML = "Please choose an option to continue."
    }
  }
});

let quantityInputs = document.querySelectorAll(".mrk-qty-item");
let allPlusButtons = document.querySelectorAll('div[data-action="increment"]');
let allMinusButtons = document.querySelectorAll('div[data-action="decrement"]');

function checkQuantities() {
  if (!step2 || !nextButton || !newnextButton) return;
  let hasNonZeroQuantity = false;
  let selectedSizes = []; // Store selected sizes

  quantityInputs.forEach(input => {
    let variantOuter = input.closest(".variant-outer");
    if (!variantOuter) return;

    if (!variantOuter.classList.contains("hidden")) {
      // mrkDebug.log(variantOuter)
      let quantity = parseInt(input.value);

      if (quantity > 0) {
        hasNonZeroQuantity = true;
        let sizeName = variantOuter.querySelector(".variant-outer--title span").textContent.trim();
        selectedSizes.push(sizeName); // Add size to the list
      }
    }
  });

  if (hasNonZeroQuantity) {
    // mrkDebug.log("✅ Selected Sizes: ", selectedSizes.join(", "));

    nextButton.classList.remove("disabled");
    newnextButton.classList.remove('disabled');
    statusEl.innerHTML = "";
    step2.querySelector(".custom-product-form-tick").classList.add("selected");

    let showATC = true;
    if (step1 && !step1.querySelector(".custom-product-form-tick").classList.contains("selected")) {
      showATC = false;
    }
    if (step2 && !step2.querySelector(".custom-product-form-tick").classList.contains("selected")) {
      showATC = false;
    }
    if (step3 && !step3.querySelector(".custom-product-form-tick").classList.contains("selected")) {
      showATC = false;
    }

    if (showATC) {
      atcButton.classList.remove("hidden");
      // nextButton.classList.add("hidden");
      newnextButton.classList.add('hidden');
    }

    if (selectedSizes.length < 2) {
      step2Label.innerHTML = `Selected Size: ${selectedSizes}`;
    }
    else if (selectedSizes.length > 1) {
      step2Label.innerHTML = `Selected Sizes: ${selectedSizes}`;
    }


  } else {
    // mrkDebug.log("⚠️ No sizes selected. Please choose at least one.");

    nextButton.classList.add("disabled");
    newnextButton.classList.add('disabled');
    statusEl.innerHTML = "Please choose a size to proceed with your order.";

    if (step2.querySelector("details").getAttribute("open") == null) {
      step2.querySelector(".custom-product-form-summary").click();
    }

    step2.querySelector(".custom-product-form-tick").classList.remove("selected");
    atcButton.classList.add("hidden");
    // nextButton.classList.remove("hidden");
    newnextButton.classList.remove('hidden');
    step2Label.innerHTML = "Select Your Size";
    if (totalSteps == "3") {
      // mrkDebug.log('hihih');
      formLabelHeading.innerHTML = "Step 2 of 3: Select Your Size for the Perfect Fit"
      nextButton.innerHTML = "Next: Confirm Your Order Details";
      // nextButton.innerHTML = "Add Logos / Add to Cart";
      newnextButton.innerHTML = "Add Logos / Add to Cart";
    }
    else if (totalSteps == "2") {
      formLabelHeading.innerHTML = "Step 2 of 2: Select Your Size for the Perfect Fit"
    }
  }
}


if (step2) {
  allPlusButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      setTimeout(() => {
        checkQuantities();
      }, 250);
    })
  });

  allMinusButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      setTimeout(() => {
        checkQuantities();
      }, 250);
    })
  });

  quantityInputs.forEach(input => {
    input.addEventListener("input", checkQuantities);
  });
}

//Ak-dd custom code
const no_add_to_cart_popup = document.querySelector(".mrk-customizer-popup-form .mrk-next-custom-no-cart.mrk-no-add-to-cart");
if(no_add_to_cart_popup){
  no_add_to_cart_popup.addEventListener('click',function(){
    const logoRowButtonNo = document.querySelector(".custom-product-form-logo-row-column-no");
    if(logoRowButtonNo){
      if (typeof window._mrkCustomizerPopupUnlockBody === 'function') window._mrkCustomizerPopupUnlockBody();
      $('.mrk-customizer-popup-form .popup-overlay').removeClass('show')
      logoRowButtonNo.click();
    }
  });
}

// No Buy Plain: use event delegation so button works even when not in DOM at load (same as stage)
document.addEventListener("click", function noBuyPlainHandler(e) {
  var logoRowButtonNo = e.target && e.target.closest && e.target.closest(".custom-product-form-logo-row-column-no");
  if (!logoRowButtonNo) return;

  console.log('[NoBuyPlain] Click detected on "No, buy plain"', { target: e.target && e.target.className, hasClosest: !!e.target.closest });
  try {
  // CRITICAL FIX: Stop ALL event propagation immediately
  e.stopImmediatePropagation();
  e.preventDefault();

  // CRITICAL FIX: Set flag FIRST - before any other logic
  window.userWantsNoCustomization = true;
  window.userWantsNoCustomizationTimestamp = Date.now();

  // CRITICAL FIX: Clear captured positions state IMMEDIATELY
  if (window.capturedPositionsForAddToCart) {
    window.capturedPositionsForAddToCart = [];
    mrkDebug.log('[No Buy Plain] 🧹 CLEARED captured positions state IMMEDIATELY');
  }

  // Immediately unbind Finish button handler to prevent it from firing
  var $finishButton = $('.mrk-final-add-to-cart');
  if ($finishButton.length > 0) {
    $finishButton.off('click.finishButton');
    $finishButton.addClass('disabled');
    $finishButton.prop('disabled', true);
    $finishButton.hide();
    mrkDebug.log('[No Buy Plain] 🚫 Flag set and handler unbound IMMEDIATELY:', {
      buttonFound: true,
      flagSet: window.userWantsNoCustomization,
      timestamp: window.userWantsNoCustomizationTimestamp,
      handlerUnbound: true,
      disabled: $finishButton.hasClass('disabled'),
      hidden: !$finishButton.is(':visible'),
      eventStopped: true
    });
  }

  $('.logo-position-checkbox:checked').prop('checked', false);
  $('.selected-position').removeClass('active');
  var $hiddenFields = $('.mrk-hidden-fields .mrk-hidden-field-item');
  var hiddenCount = $hiddenFields.length;
  $hiddenFields.remove();

  mrkDebug.log('[No Buy Plain] ✅ State cleared:', {
    flag: window.userWantsNoCustomization,
    timestamp: window.userWantsNoCustomizationTimestamp,
    time: new Date().toISOString(),
    checkboxesCleared: $('.logo-position-checkbox:checked').length === 0,
    capturedPositionsCleared: !window.capturedPositionsForAddToCart || window.capturedPositionsForAddToCart.length === 0,
    hiddenFieldsCleared: hiddenCount
  });

  /* Close customizer popup and unlock body so cart notification is visible (mobile multistep PDP) */
  var $overlay = $('.mrk-customizer-popup-form .popup-overlay.show');
  if ($overlay.length) {
    if (typeof window._mrkCustomizerPopupUnlockBody === 'function') window._mrkCustomizerPopupUnlockBody();
    $overlay.removeClass('show');
  }

  logoRowButtonNo.classList.add("selected");
  var step3El = logoRowButtonNo.closest(".step-3");
  if (step3El) {
    var tick = step3El.querySelector(".custom-product-form-tick");
    if (tick) tick.classList.add("selected");
  }

  var hasNonZeroQuantity = false;
  var quantityInputsDefined = typeof quantityInputs !== "undefined" && quantityInputs && quantityInputs.forEach;
  if (quantityInputsDefined) {
    quantityInputs.forEach(function(input) {
      var outer = input.closest && input.closest(".variant-outer");
      if (outer && !outer.classList.contains("hidden") && parseInt(input.value, 10) > 0) {
        hasNonZeroQuantity = true;
      }
    });
  }
  console.log('[NoBuyPlain] Quantity check', { quantityInputsDefined: !!quantityInputsDefined, quantityInputsLength: quantityInputsDefined ? quantityInputs.length : 0, hasNonZeroQuantity: hasNonZeroQuantity, step1: !!step1, step2: !!step2, nextButton: !!nextButton });

  if (hasNonZeroQuantity) {
    if (nextButton) {
      nextButton.classList.remove("disabled");
    }
    if (newnextButton) {
      newnextButton.classList.remove("disabled");
    }
    if (statusEl) {
      statusEl.innerHTML = "";
    }
    if (step2) {
      var tick2 = step2.querySelector(".custom-product-form-tick");
      if (tick2) tick2.classList.add("selected");
    }
    var showATC = true;
    if (step1) {
      var t1 = step1.querySelector(".custom-product-form-tick");
      if (t1 && !t1.classList.contains("selected")) showATC = false;
    }
    if (step2) {
      var t2 = step2.querySelector(".custom-product-form-tick");
      if (t2 && !t2.classList.contains("selected")) showATC = false;
    }
    if (step3El) {
      var t3 = step3El.querySelector(".custom-product-form-tick");
      if (t3 && !t3.classList.contains("selected")) showATC = false;
    }
    if (showATC) {
      var $finishButtonCheck = $('.mrk-final-add-to-cart');
      var finishButtonDisabled = $finishButtonCheck.length === 0 ||
        $finishButtonCheck.hasClass('disabled') ||
        !$finishButtonCheck.is(':visible') ||
        $finishButtonCheck.prop('disabled') === true;
      mrkDebug.log('[No Buy Plain] 🎯 About to trigger add-to-cart click, flag state:', {
        flag: window.userWantsNoCustomization,
        timestamp: window.userWantsNoCustomizationTimestamp,
        finishButtonDisabled: finishButtonDisabled,
        finishButtonVisible: $finishButtonCheck.is(':visible'),
        finishButtonFound: $finishButtonCheck.length > 0,
        handlerUnbound: true
      });
      if (!finishButtonDisabled && $finishButtonCheck.length > 0) {
        $finishButtonCheck.addClass('disabled');
        $finishButtonCheck.prop('disabled', true);
        $finishButtonCheck.hide();
        $finishButtonCheck.off('click.finishButton');
        mrkDebug.log('[No Buy Plain] ⚠️ Finish button was still enabled - forced disable and unbind');
      }
      setTimeout(function() {
        var atc = document.querySelector(".single-product__add-to-cart");
        console.log('[NoBuyPlain] Triggering ATC click', { atcFound: !!atc, selector: '.single-product__add-to-cart' });
        if (atc) atc.click();
      }, 10);
    } else {
      console.log('[NoBuyPlain] showATC was false — step ticks not all selected', { step1: !!step1, step2: !!step2, step3El: !!step3El });
    }
  } else if (quantityInputsDefined && quantityInputs.length === 0) {
    /* No legacy .mrk-qty-item inputs (e.g. multistep PDP). Sync pdp-v2 hidden inputs then trigger main ATC. */
    if (window._noBuyPlainAtcTriggered) {
      return;
    }
    window._noBuyPlainAtcTriggered = true;
    setTimeout(function() {
      window._noBuyPlainAtcTriggered = false;
    }, 3000);

    console.log('[NoBuyPlain] No legacy quantity inputs — triggering main ATC (plain add)');
    var $finishBtn = $('.mrk-final-add-to-cart');
    if ($finishBtn.length) {
      $finishBtn.off('click.finishButton').addClass('disabled').prop('disabled', true).hide();
    }
    var productForm = document.querySelector('product-form-mrk form');
    if (productForm) {
      var idInputs = productForm.querySelectorAll('input[name="id"], select[name="id"]');
      for (var i = 0; i < idInputs.length; i++) {
        idInputs[i].setAttribute('disabled', 'disabled');
      }
      var singleQty = productForm.querySelector('input[name="quantity"]:not([name^="items"])');
      if (singleQty) {
        singleQty.setAttribute('disabled', 'disabled');
      }
    }
    var pdpForm = document.querySelector('pdp-multistep-form-v2');
    console.log('[NoBuyPlain] pdp-v2 sync', { pdpFormFound: !!pdpForm, hasSync: !!(pdpForm && typeof pdpForm._syncHiddenInputs === 'function') });
    if (pdpForm && typeof pdpForm._syncHiddenInputs === 'function') {
      pdpForm._syncHiddenInputs();
    }
    var formInputs = productForm ? productForm.querySelectorAll('.mrk-qty-item') : [];
    var inputDetail = [];
    for (var j = 0; j < formInputs.length; j++) {
      var inp = formInputs[j];
      inputDetail.push({ variantId: inp.getAttribute('data-variant-id'), value: inp.value, name: inp.name });
    }
    console.log('[NoBuyPlain] After sync — .mrk-qty-item in product form', { count: formInputs.length, inputs: inputDetail });
    setTimeout(function() {
      var atc = document.querySelector(".single-product__add-to-cart");
      console.log('[NoBuyPlain] Triggering ATC (no legacy inputs)', { atcFound: !!atc });
      if (atc) atc.click();
    }, 10);
  } else {
    console.log('[NoBuyPlain] No quantity selected — showing "Please choose a size"', { step2: !!step2 });
    if (nextButton) {
      nextButton.classList.add("disabled");
    }
    if (newnextButton) {
      newnextButton.classList.add("disabled");
    }
    if (statusEl) {
      statusEl.innerHTML = "Please choose a size to proceed with your order.";
    }
    if (step2) {
      var details = step2.querySelector("details");
      if (details && details.getAttribute("open") == null) {
        var sum = step2.querySelector(".custom-product-form-summary");
        if (sum) sum.click();
      }
      var tick2 = step2.querySelector(".custom-product-form-tick");
      if (tick2) tick2.classList.remove("selected");
    }
    if (atcButton) {
      atcButton.classList.add("hidden");
    }
    if (newnextButton) {
      newnextButton.classList.remove("hidden");
    }
    if (formLabelHeading) {
      if (totalSteps == "3") {
        formLabelHeading.innerHTML = "Step 2 of 3: Select Your Size for the Perfect Fit";
        if (nextButton) nextButton.innerHTML = "Next: Confirm Your Order Details";
      } else if (totalSteps == "2") {
        formLabelHeading.innerHTML = "Step 2 of 2: Select Your Size for the Perfect Fit";
      }
    }
  }
  } catch (err) {
    console.error('[NoBuyPlain] Error in handler', err);
  }
});